import * as React from 'react';
import { Field, FieldProps } from '@websky/core/src/Passenger/components/Field/Field';

const PassengerFormField: React.FC<FieldProps> = props => {
	return <Field {...props} variant="standard" />;
};

export default PassengerFormField;
